import { useLocalStorage as useMantineLocalStorage } from '@mantine/hooks';

export const useLocalStorage = useMantineLocalStorage;
